import { EventEmitter } from './EventEmitter';

/**
 * Custom event emitter for managing Loggers during tests
 */
export const loggerTestingEventEmitter = new EventEmitter();
//# sourceMappingURL=loggerResetEventEmitter.js.map